import BeIdCard from './BeIdCard';

export default BeIdCard;
